import React, { createContext, useEffect, useState } from 'react';
import { getAuth, onIdTokenChanged } from 'firebase/auth'; // v9 modular
import { firebaseConfig } from './firebase';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    console.log("Setting up auth state listener");
    // onIdTokenChanged fires on login, logout AND on every token refresh
    // (~hourly while the tab is open), so the extension always receives a
    // fresh ID token to call the gate Cloud Function with.
    const unsubscribe = onIdTokenChanged(auth, async (user) => {
      if (user) {
        console.log("sending logged in msg");

        setUser(user);
        const { uid, displayName, email, photoURL } = user;

        // Forward auth to the Aidify browser extension so it can authenticate
        // calls to the report-gate Cloud Function. The apiKey is already public
        // (it ships in the client bundle); the refresh token lets the extension
        // mint fresh ID tokens via Google's secure-token endpoint.
        let authBlob = null;
        try {
          // Force a refresh so user.refreshToken is reliably populated — it can
          // be an empty string on the first onIdTokenChanged callback before the
          // initial token round-trip, which would store an unusable auth blob.
          await user.getIdToken(/* forceRefresh */ true);
          const result = await user.getIdTokenResult();
          // Re-read the refresh token; fall back to the live currentUser.
          const refreshToken = user.refreshToken || getAuth().currentUser?.refreshToken;
          if (refreshToken) {
            authBlob = {
              idToken: result.token,
              refreshToken,
              expiresAt: new Date(result.expirationTime).getTime(),
              apiKey: firebaseConfig.apiKey,
            };
          }
        } catch (err) {
          console.error("Failed to get ID token for extension bridge", err);
          // Leave authBlob null — the extension routes a null auth to its
          // "Reconnect" path instead of falsely treating the user as signed out.
        }

        window.postMessage({ type: 'LOGIN_SUCCESS', user: { uid, displayName, email, photoURL }, auth: authBlob }, '*');
      } else {
        window.postMessage({ type: 'LOGOUT' }, '*');

        setUser(null);
      }
    });


    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  );
}
